import { render } from "./HomeView2.vue?vue&type=template&id=202f6353&scoped=true"
import script from "./HomeView2.vue?vue&type=script&lang=js"
export * from "./HomeView2.vue?vue&type=script&lang=js"

import "./HomeView2.vue?vue&type=style&index=0&id=202f6353&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_269ca4a85a7eca3d5d7c9cc630d4bd5a/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-202f6353"]])

export default __exports__